<div class="card card-custom">
    <div class="card-header header-background">
        <div class="card-title">
            <h3 class="card-label title-style">{{getComponentTitle()}}
            </h3>
        </div>
    </div>
    <form class="form" [formGroup]="projectForm">
        <div class="card-body style-css">
            <div class="sub-title-style">
                General Panel Details
            </div>
            <div class="card-body-progress">
                <mat-spinner [diameter]="20"></mat-spinner>
            </div>
            <div class="form-group row style-form">
                <div class="col-lg-6 kt-margin-bottom-20-mobile">
                    <mat-form-field id="project" class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Project Title </mat-label>
                        <input matInput placeholder="Enter Project Title" formControlName="title" maxlength="50" />
                        <mat-error>Title is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                        <strong>Title</strong>
                    </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                    <mat-form-field id="panelname" class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Panel Name</mat-label>

                        <input matInput placeholder="Enter Panel Name" formControlName="panelname" />
                        <mat-error>Panel Name is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                        <strong>Mobile</strong>
                    </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                    <mat-form-field id="date" class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Date</mat-label>

                        <input matInput [matDatepicker]="picker" formControlName="orginDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error>Date is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                        <strong>Telephone</strong>
                    </mat-hint> -->
                    </mat-form-field>
                </div>
            </div>
            <div id="border-bottom" class="form-group row style-form">
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                    <mat-form-field id="reference" class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Reference</mat-label>

                        <input matInput placeholder="Enter Reference" formControlName="version" />
                        <mat-error>Reference is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                        <strong>Mobile</strong>
                    </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                    <mat-form-field id="approver" class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Approved By</mat-label>

                        <input matInput placeholder="Enter Approver" formControlName="approvedBy" />
                        <mat-error>Approver is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                        <strong>Approver</strong>
                    </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                    <mat-form-field id="designer" class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Designer</mat-label>

                        <input matInput placeholder="Enter Designer" formControlName="designer" value="{{userName}}"
                            readonly />

                        <mat-error>Designer is
                            <strong>required</strong>
                        </mat-error>

                    </mat-form-field>
                </div>


                <!-- <div class="col-lg-3 kt-margin-bottom-20-mobile">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Customer Name</mat-label>

                        <mat-select placeholder="Enter Customer Name" formControlName="customerName"
                            (selectionChange)="getCustomerDetail($event)">
                            <mat-option value="">Choose Customer Name</mat-option>
                            <mat-option *ngFor="let cus of loadedCustomers"
                                [value]="cus.uuid">{{cus.customername}}</mat-option>
                        </mat-select>
                        <mat-error>Customer Name is
                            <strong>required</strong>
                        </mat-error>

                    </mat-form-field>
                </div> -->

            </div>



            <!-- <input  type="hidden"  formControlName="customerName"  >
            <input  type="hidden"  formControlName="customerId"  > -->

            <div class="sub-title-style">
                Client Details
            </div>
            <div class="form-group row style-form" formGroupName="customerName">
                <div class="col-lg-6 kt-margin-bottom-20-mobile">
                    <mat-form-field id="client" class="mat-form-field-fluid">
                        <mat-label>Client Name</mat-label>
                        <input type="text" class="client-input" placeholder="Search for Customer"
                            aria-label="Customer Name" matInput [formControl]="myControl" [matAutocomplete]="auto"
                            [value]="displaySelectedCustomer(myControl.value) ? displaySelectedCustomer(myControl.value) : projectForm.get('customerName').value"
                            (input)="onCustomerNameInput($event.target.value)" />

                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn"
                            (optionSelected)="onCustomerSelected($event.option.value)">
                            <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer.uuid">
                                {{ customer.customername }}
                            </mat-option>
                        </mat-autocomplete>

                        <mat-error *ngIf="myControl.hasError('required')">
                            Client is <strong>required</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="form-group row style-form" formGroupName="address">
                <div class="col-lg-6 kt-margin-bottom-20-mobile">
                    <mat-form-field id="address" class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Address Line</mat-label>

                        <input matInput placeholder="Enter Address" formControlName="addressLine" />
                        <!-- <mat-hint align="start">Please enter
                            <strong>Address</strong>
                        </mat-hint> -->
                        <mat-error>Address is
                            <strong>required</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                    <mat-form-field id="country" class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Country</mat-label>

                        <input matInput placeholder="Enter Country" formControlName="country" />
                        <!-- <mat-hint align="start">Please enter
                            <strong>Country</strong>
                        </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Email ID</mat-label>
                        <input matInput placeholder="Enter Email" formControlName="email">
                    </mat-form-field>
                    <!-- <mat-hint align="start">Please enter
                            <strong>Country</strong>
                        </mat-hint> -->
                </div>
            </div>
            <div class="form-group row style-form" formGroupName="address">
                <div class="col-lg-2 kt-margin-bottom-20-mobile">
                    <mat-form-field id="city" class="mat-form-field-fluid" appearance="outline">
                        <mat-label>City</mat-label>

                        <input matInput placeholder="Enter City" formControlName="city" />
                        <!-- <mat-hint align="start">Please enter
                            <strong>City</strong>
                        </mat-hint> -->
                    </mat-form-field>
                </div>

                <div class="col-lg-2 kt-margin-bottom-20-mobile">
                    <mat-form-field id="state" class="mat-form-field-fluid" appearance="outline">
                        <mat-label>State</mat-label>

                        <input matInput placeholder="Enter State" formControlName="state" />
                        <!-- <mat-hint align="start">Please enter
                            <strong>State</strong>
                        </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-2 kt-margin-bottom-20-mobile">
                    <mat-form-field id="postal" class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Postal</mat-label>

                        <input matInput placeholder="Enter Postal Code" formControlName="postCode" />
                        <!-- <mat-hint align="start">Please enter
                            <strong>postCode</strong>
                        </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                    <mat-form-field id="telephone" class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Telephone</mat-label>

                        <input matInput placeholder="Enter Telephone" formControlName="telephone"
                            (input)="onTelephoneInput($event)" #telephoneInput />
                        <mat-error>Telephone is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                    <strong>Telephone</strong>
                </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                    <mat-form-field id="mobile" class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Mobile</mat-label>

                        <input matInput placeholder="Enter Mobile" formControlName="mobile"
                            (input)="onTelephoneInput($event)" />
                        <mat-error>Mobile is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                    <strong>Mobile</strong>
                </mat-hint> -->
                    </mat-form-field>
                </div>
            </div>
            <div id="border-bottom" class="form-group row style-form">

            </div>
            <div class="sub-title-style">
                Technical Specification | IEC Standard - 61439
            </div>
            <div class="form-group row style-form">
                <div class="col-lg-2 kt-margin-bottom-20-mobile">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Ampere rating</mat-label>
                        <input type="text" matInput placeholder="Enter or select Ampere rating"
                            formControlName="voltage" [matAutocomplete]="voltageAuto" />
                        <mat-autocomplete #voltageAuto="matAutocomplete">
                            <mat-option *ngFor="let type of filteredVoltageOptions | async" [value]="type">
                                {{ type }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error>Ampere rating is <strong>required</strong></mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-2 kt-margin-bottom-20-mobile" *ngIf="(!IsKikMember)">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Form Type</mat-label>

                        <mat-select placeholder="Form Type" formControlName="formType">
                            <mat-option value="">Choose Form Type</mat-option>
                            <mat-option *ngFor="let type of formType" [value]="type">{{type}}</mat-option>
                        </mat-select>
                        <mat-error>Form Type is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                        <strong>Telephone</strong>
                    </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-2 kt-margin-bottom-20-mobile" *ngIf="(IsKikMember)">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Form Type</mat-label>
                        <mat-select placeholder="Form Type" formControlName="formType">
                            <mat-option value="">Choose Form Type</mat-option>
                            <mat-option value="Form 1">Form 1</mat-option>
                            <mat-option value="Form 2a">Form 2a</mat-option>
                            <mat-option value="Form 2b">Form 2b</mat-option>
                            <mat-option value="Form 3a">Form 3a</mat-option>
                            <mat-option value="Form 3b">Form 3b</mat-option>

                            <!-- Grouping Form 4a Submenu -->
                            <mat-optgroup label="Form 4a">
                                <mat-option value="Form 4a Type 1">Form 4a Type 1</mat-option>
                                <mat-option value="Form 4a Type 2">Form 4a Type 2</mat-option>
                                <mat-option value="Form 4a Type 3">Form 4a Type 3</mat-option>
                            </mat-optgroup>

                            <!-- Grouping Form 4b Submenu -->
                            <mat-optgroup label="Form 4b">
                                <mat-option value="Form 4b Type 4">Form 4b Type 4</mat-option>
                                <mat-option value="Form 4b Type 5">Form 4b Type 5</mat-option>
                                <mat-option value="Form 4b Type 6">Form 4b Type 6</mat-option>
                            </mat-optgroup>

                        </mat-select>
                        <mat-error>Form Type is <strong>required</strong></mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-2 kt-margin-bottom-20-mobile" *ngIf="(role !== 'superadmin' || !IsKikMember)">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Short Circuit Current</mat-label>

                        <mat-select placeholder="Short Circuit Current" formControlName="shortCircuitTime">
                            <mat-option value="">Choose Short Circuit Time</mat-option>
                            <mat-option *ngFor="let type of shortCircuitTime" [value]="type">{{type}}</mat-option>
                        </mat-select>
                        <mat-error>Short Circuit Time is
                            <strong>required</strong>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-lg-2 kt-margin-bottom-20-mobile" *ngIf="(role === 'superadmin' || IsKikMember)">
                    <mat-form-field id="shortCircuitTime" class="mat-form-field-fluid custom-input-field">
                        <mat-label>Short Circuit Current</mat-label>
                        <input type="text" matInput [formControl]="shortCircuitControl" [matAutocomplete]="autoOptions"
                            placeholder="Search for Short Circuit Current" class="client-input" />

                        <mat-autocomplete #autoOptions="matAutocomplete">
                            <mat-option *ngFor="let option of filteredShortCircuitOptions | async" [value]="option">
                                {{ option }}
                            </mat-option>
                        </mat-autocomplete>

                        <mat-error *ngIf="shortCircuitControl.hasError('required')">
                            Short Circuit Current is <strong>required</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-2 kt-margin-bottom-20-mobile">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Cable Direction</mat-label>

                        <mat-select placeholder="Cable Direction" formControlName="cabledirection">
                            <mat-option value="">Choose Cable Direction</mat-option>
                            <mat-option *ngFor="let type of cabledirection" [value]="type">{{type}}</mat-option>
                        </mat-select>
                        <mat-error>Cable Direction is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                        <strong>Mobile</strong>
                    </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Depth</mat-label>

                        <mat-select placeholder="Depth option" formControlName="depthoption"
                            panelClass="depth-select-panel">
                            <mat-select-trigger *ngIf="projectForm.get('depthoption').value as d">
                                {{ d.component }} + {{ d.busbar }} = {{ d.total }} mm
                            </mat-select-trigger>
                            <mat-option value="">Choose depth </mat-option>
                            <mat-option *ngFor="let type of depthoption" [value]="type">Component: {{ type.component }} | Busbar: {{ type.busbar }} | Total: {{ type.total }}</mat-option>
                        </mat-select>
                        <mat-hint>Component + Busbar = Total depth</mat-hint>
                        <mat-error>Depth is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                        <strong>Mobile</strong>
                    </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-2 kt-margin-bottom-20-mobile">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Ip Rating</mat-label>

                        <mat-select placeholder="Ip Rating" formControlName="ipRating">
                            <mat-option value="">Choose Ip Rating</mat-option>
                            <mat-option *ngFor="let ipr of ipRating" [value]="ipr">{{ipr}}</mat-option>
                        </mat-select>
                        <mat-error>Ip Rating is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                        <strong>Telephone</strong>
                    </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-2 kt-margin-bottom-20-mobile">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Earthing System</mat-label>

                        <mat-select placeholder="Earthing System" formControlName="earthingSystem">
                            <mat-option value="">Choose Earthing System</mat-option>
                            <mat-option *ngFor="let es of earthingSystem" [value]="es">{{es}}</mat-option>
                        </mat-select>
                        <mat-error>Earthing System is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                        <strong>Telephone</strong>
                    </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-2 kt-margin-bottom-20-mobile">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Colour</mat-label>

                        <mat-select placeholder="Colour" formControlName="colour">
                            <mat-option value="">Choose Colour</mat-option>
                            <mat-option *ngFor="let col of colour" [value]="col">{{col}}</mat-option>
                        </mat-select>
                        <mat-error>Colour is
                            <strong>required</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-2 kt-margin-bottom-20-mobile">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Encholser Frame Color</mat-label>

                        <mat-select placeholder="Colour" formControlName="innerProfileColour">
                            <mat-option value="">Choose Colour</mat-option>
                            <mat-option *ngFor="let col of colour" [value]="col">{{col}}</mat-option>
                        </mat-select>
                        <mat-error>Colour is
                            <strong>required</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Busbar Location</mat-label>

                        <mat-select placeholder="Busbar Location" formControlName="busbarLocation">
                            <mat-option value="">Choose Busbar Location</mat-option>
                            <mat-option *ngFor="let type of busbarLocation" [value]="type">{{type}}</mat-option>
                        </mat-select>
                        <mat-error>Busbar Location is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                        <strong>Mobile</strong>
                    </mat-hint> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile" style="display: none;">
                    <mat-form-field class="mat-form-field-fluid" appearance="outline">
                        <mat-label>Iec Standard</mat-label>

                        <mat-select placeholder="Earthing System" formControlName="iecStandard">
                            <mat-option value="">Choose Earthing System</mat-option>
                            <mat-option *ngFor="let iecs of iecStandard" [value]="iecs">{{iecs}}</mat-option>
                        </mat-select>
                        <mat-error>Iec Standard is
                            <strong>required</strong>
                        </mat-error>
                        <!-- <mat-hint align="start">Please enter
                        <strong>Telephone</strong>
                    </mat-hint> -->
                    </mat-form-field>
                </div>
            </div>



        </div>
        <div id="projectForm" class="card-footer two-btns-padding">
            <div class="d-flex justify-content-center">
                <div class="mr-2"></div>
                <div>
                    <button class="style-nxt-btn" type="button"
                        *ngIf="projectForm.valid && !myControl.hasError('required')" mat-raised-button
                        (click)="onSumbit(false)" matTooltip="Save changes">
                        Next
                    </button>

                    <button class="space-between-butns" type="button" mat-raised-button [mat-dialog-close]="data"
                        matTooltip="Cancel changes">
                        Cancel
                    </button>&nbsp;
                </div>
            </div>
        </div>
    </form>
</div>